module.exports = __webpack_public_path__ + "img/BG2.430d01f2.png";